<div class="container-fliud">
    <div class="row">
        <div class="doc-tabs">
            <div class="doc-grid equalColorRows h-100 d-flex flex-column position-relative">
              <app-ag-grid class="center-Pagination"
                [style.height]="'22rem'"
                [columnSettings]="false"
                [getRowStyle]="getRowStyle"
                [dataModel]="AgGridDataModel"
                [rowData]="data?.selectedRowData??[]"
                (gridReady)="onGridReady($event)" 
                (onPagination)="onPagination($event)" 
                (onSelectionChange)="onSelectionChange($event)"
                (onSelectOptionClick)="onSelectOptionClick($event)"
                [handleCustomHeaderDisplay]="false">
              </app-ag-grid>
            </div>
          </div>

    </div>
</div>
